import {
  GROUP_FILTER,
  CATEGORY_FILTER,
  OEM_FILTER,
  UOM_FILTER,
  STATUS_FILTER,
  ITEM_GMDS_CODE_FILTER,
  ITEM_DESCRIPTION_FILTER,
  PRIORITY_ONE_ENGINEER_FILTER,
  PRIORITY_TWO_ENGINEER_FILTER,
  PRIORITY_THREE_ENGINEER_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    category_id: "",
    uom_id: "",
    gmds_code: "",
    name: "",
    group_id: "",
    oem_id: "",
    priority_1_user_id: "",
    priority_2_user_id: "",
    priority_3_user_id: "",
    min_stock_qty: "",
    descriptions: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_masters",
    schema: schema,
    include: [
      {
        model: "category_masters",
        as: "category",
      },
      {
        model: "uom_masters",
        as: "uom",
      },
      {
        model: "oem_master",
        as: "oem",
      },
      {
        model: "group_master",
        as: "group",
      },
      {
        model: "user_masters",
        as: "priorityOneUser",
      },
      {
        model: "user_masters",
        as: "priorityTwoUser",
      },
      {
        model: "user_masters",
        as: "priorityThreeUser",
      },
    ],
  };

  const navigatePage = { back: "/item-list" };

  const headerName = "Item";

  const validationType = "ItemCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "material_masters",
      initialPayload: {
        modelName: "material_masters",
        schema: schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_masters",
    schema: schema,
    include: [
      {
        model: "category_masters",
        as: "category",
      },
      {
        model: "uom_masters",
        as: "uom",
      },
      {
        model: "oem_master",
        as: "oem",
      },
      {
        model: "group_master",
        as: "group",
      },
      {
        model: "user_masters",
        as: "priorityOneUser",
      },
      {
        model: "user_masters",
        as: "priorityTwoUser",
      },
      {
        model: "user_masters",
        as: "priorityThreeUser",
      },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "GMDS Code", value: "gmds_code" },
    { label: "Item Description", value: "descriptions" },
    { label: "Category Type", value: "category_type" },
    { label: "Category Name", value: "category.name" },
    { label: "UOM Name", value: "uom.name" },
    { label: "OEM Name", value: "oem.name" },
    { label: "Group Name", value: "group.name" },
    { label: "Priority 1 Engineer", value: "priorityOneUser.full_name" },
    { label: "Priority 2 Engineer", value: "priorityTwoUser.full_name" },
    { label: "Priority 3 Engineer", value: "priorityThreeUser.full_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/item-create",
    edit: "/item-create",
    view: "/item-view",
  };

  const searchfields = [
    "name",
    "code",
    "gmds_code",
    "category.name",
    "uom.name",
    "group.name",
    "oem.name",
    "priorityOneUser.first_name",
    "priorityTwoUser.first_name",
    "priorityThreeUser.first_name",
    "descriptions",
  ];

  const headerName = "Item";
  const endpoint = "/getRecords";
  const exportFileName = "MaterialData.xlsx";

  const filterConfig = [
    ITEM_GMDS_CODE_FILTER,
    ITEM_DESCRIPTION_FILTER,
    GROUP_FILTER,
    CATEGORY_FILTER,
    OEM_FILTER,
    UOM_FILTER,
    PRIORITY_ONE_ENGINEER_FILTER,
    PRIORITY_TWO_ENGINEER_FILTER,
    PRIORITY_THREE_ENGINEER_FILTER,
    STATUS_FILTER,
  ];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "material_masters",
  schema: schema,
  include: [
    { model: "category_masters", as: "category" },
    { model: "uom_masters", as: "uom" },
    { model: "oem_master", as: "oem" },
    { model: "group_master", as: "group" },
    { model: "user_masters", as: "priorityOneUser" },
    { model: "user_masters", as: "priorityTwoUser" },
    { model: "user_masters", as: "priorityThreeUser" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
